import { laptopMediumMax, mobileXXLargeMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled from 'styled-components';
import { MAX_WIDTH } from '../layout/PageWrapper.style';

export const LoadingBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 300px;
`;

export const Container = styled.div`
  margin: 10px auto 30px;
  max-width: ${MAX_WIDTH}px;
  padding: 0 30px;
  width: 100%;

  @media (${laptopMediumMax}) {
    padding: 0 15px;
  }
`;

export const SchoolTitle = styled.h4`
  font-size: 16px;
  font-weight: bold;
  color: ${({ theme }) => theme.textDark};

  span {
    display: inline-block;
  }

  button {
    margin-top: 5px;
  }
`;

export const SchoolInfoRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  flex-wrap: wrap;
  margin: 10px 0 30px;

  @media (${mobileXXLargeMax}) {
    flex-wrap: nowrap;
    flex-direction: column;
    gap: 5px;
  }
`;

export const SchoolInfo = styled.span<{ $hasIcon?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
  padding-right: 10px;
  border-right: 2px solid ${({ theme }) => theme.primary};
  color: ${({ theme }) => theme.textDark};
  font-size: 14px;

  &:last-child {
    border-right: none;
  }

  a {
    color: ${({ theme }) => theme.primary};
    text-decoration: underline;

    &:hover {
      color: ${({ theme }) => theme.backgroundMid};
    }
  }

  @media (${mobileXXLargeMax}) {
    border-right: none;
    padding-left: ${({ $hasIcon }) => ($hasIcon ? '0px' : '15px')};
  }
`;
